// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Attachment = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M23 10s-8.6261 8.5424-12.5843 12.5007c-1.8027 1.8026-5.7304 2.186-7.9165-.0001-2.186-2.186-1.8027-6.1137 0-7.9164L14.374 2.7096c.9013-.9014 2.8652-1.093 3.9582 0s.9013 3.0568 0 3.9582L7 18" /></React.Fragment>, },
  'default'
);
